<template>
    <div>
        <vue-html2pdf
        :show-layout="false"
        :enable-download="false"
        :preview-modal="false"
        :paginate-elements-by-height="1200"
        :filename= "nomeArquivo"
        :pdf-quality="2"
        :manual-pagination="true"
        pdf-format="a4"
        :pdf-margin="10"
        pdf-orientation="portrait"
        pdf-content-width="800px"
        @beforeDownload="abrirNovaGuia"
        ref="html2Pdf">
        <section slot="pdf-content">
          <div class="container-pdf">
          <div class="title-template">
            <div class="info-pdf w-100">
              <div class="numberApr w-75">
                <div class="iconHat mr-2">
                  <i class="fas fa-hard-hat m-2" style="color:#008144"></i>
                </div>
                <div class="titleNumberApr">{{ aprSelected.codigoAtividade }} ({{ aprSelected.atividade }})</div>
              </div>
              <div class="numbreRevisao w-25">
                <div class="font-title mr-2">Revisão:</div>
                <div class="revisao">{{ aprSelected.revisao }}</div>
              </div>
            </div>
            <div class="dateResponsable w-100">
              <div class="dateApr w-30">
                <div class="font-title mr-2">Data:</div>
                <div class="font-info">{{ aprSelected.dataExecucaoFormatada }}</div>
              </div>
              <div class="dateExpire w-30">
                <div class="font-title mr-2">Vencimento:</div>
                <div class="font-info"> {{ aprSelected.dataValidadeAPRFormatada }} </div>
              </div>
              <div class="responsableApr">
                <div class="font-title mr-2">Responsável:</div>
                <div class="font-info">{{ aprSelected.responsavel }}</div>
              </div>
            </div>
            <div class="addressApr">
              <div class="addressDiv w-100">
                <div class="font-title mr-2">Endereço:</div>
                <div class="font-info"> {{ aprSelected.cidade + '-' + aprSelected.estado + ', ' + aprSelected.endereco + ' - ' + aprSelected.numero  }} </div>
              </div>
            </div>
          </div>
          <div class="analysis-template">
            <div class="title-risk mb-2">
              MATRIZ DE ANÁLISE DE RISCO
            </div>
            <div class="analysisRisk mb-2">
              <div class="lfAnalysis w-100">
                <div class="font-title mr-2 mb-2">MATRIZ ANÁLISE DE RISCO:</div>
                <div class="statusTemplate"
                  :style="{'color': aprSelected.colorFontStatusApr}">
                      {{ aprSelected.statusAPRDescricao }}
                    </div>
              </div>
            </div>
            <hr>
            <div class="mb-2">
              <div class="title-checklist">
                AVALIAÇÃO
              </div>
              <div class="checklist">
                <!-- <detailsApr ref="detailsApr" :isPdf="true" :propApr="propApr"></detailsApr> -->
              </div>
            </div>
            <hr v-if="listMidia.length !== 0">
            <div class="mb-2" style="break-inside: avoid;" v-if="listMidia.length !== 0">
              <div class="title-medias">MÍDIAS</div>
              <!-- <mediasApr ref="mediaApr" :isPdf="true" :listMidia="listMidia"></mediasApr> -->
            </div>
            <hr>
            <div class="signaturelists">
              <div class="title-signature mb-2 w-100">ASSINATURAS</div>
                  <div class="container_ocorrencias_filtradas">
                    <div class="numero_oce font">Mátricula</div>
                    <div class="tecnico_oce font">Responsável</div>
                    <div class="engenheiro_oce font">Cargo</div>
                    <div class="causa_raiza font">Assinatura</div>
                  </div>
                  <div class="container_ocorrencias w-100 mb-2" v-for=" (obj,index) in assinaturaList" :key="index">
                    <div class="numero_oce_result font_result w-25">{{obj.matricula !== null ? obj.matricula : obj.documentoAssinatura}}</div>
                    <div class="tecnico_oce_result font_result w-25">{{obj.nomeFuncionario !== null ? obj.nomeFuncionario : obj.nomeAssinatura}}</div>
                    <div class="engenheiro_oce_result font_result w-25">{{obj.cargo !== null ? obj.cargo : 'N/D'}}</div>
                    <div class="causa_raiza_result w-25">
                      <img class="icone-img"  :src="`${`data:image/${obj.extensao}`};base64,`+ obj.img64"/>
                    </div>
                </div>
            </div>
          </div>
        </div>
        </section>
        </vue-html2pdf>
    </div>
</template>

<script>

import ActionsForm from '@/shared/mixins/actionsForm'
import HeadDetailsGama from '@/views/private/realestate/components/HeadDetails.vue'
import inqueryQmaRepository from '@/shared/http/repositories/business/qmaInquery'
import { loading } from '@/shared/utils/UIHelper'
import VueHtml2pdf from 'vue-html2pdf'
import cabecalhoPng from '../../../../../../../../../../static/img/realestate/relatorio/cabecalho.png'

export default {
  name: 'tableInqueryQmaPivs',
  mixins: [ActionsForm],
  components: {
    HeadDetailsGama,
    VueHtml2pdf
  },
  props: ['qma'],
  data () {
    return {
      colunas: ['CÓD. PIVS', 'CÓD. OBRA', 'STATUS', 'RESPONSÁVEL', 'DATA INICIAL', 'DATA FINAL', ''],
      listaPivs: [],
      formSearch: {
        NumeroQma: null,
        Fluxo: null,
        CodigoAtividade: null,
        Obra: null,
        ResponsavelId: null,
        StatusQMA: null,
        Local: null,
        DataExecucaoQMAInicio: null,
        DataExecucaoQMAFinal: null,
        equipamento: null,
        Revisao: null
      },
      form: {
        categoria: null,
        descricao: null
      },
      isTechnical: false,
      dataFormatada: null,
      listMidia: [],
      dataRelatorio: null,
      dataInicioFormatado: null,
      dataFimFormatado: null,
      codQma: '',
      idPdf: false,
      assinaturaList: [],
      midiapdf: null,
      midiapdfList: [],
      aprSelected: {
        arquivoID: null,
        arquivoNome: '',
        atividade: '',
        cidade: '',
        codigoAtividade: '',
        colorBackgroundStatusApr: '',
        colorFontStatusApr: '',
        dataExecucaoAPR: null,
        dataExecucaoAPRFormatada: '',
        dataValidadeAPR: null,
        dataValidadeAPRFormatada: 'null',
        descricaoAtividade: '',
        endereco: '',
        estado: '',
        numero: '',
        id: null,
        local: '',
        matricula: null,
        obraid: null,
        offline: null,
        offlineDescricao: '',
        referenciaObra: '',
        responsavel: '',
        revisao: '',
        status: null,
        statuApr: null,
        statuaAPRDescricao: '',
        signatureResponsable: '',
        signatureResponsabletype: null,
        signatureTechnical: '',
        signatureTechnicaltype: null,
        signatureClient: '',
        signatureClienttype: null,
        type: null
      }
    }
  },

  watch: {
  },

  computed: {
    nomeArquivo () {
      return `QMA - ${this.qma === 0 ? 'LV' : this.qma === 1 ? 'PIT' : this.qma === 2 ? 'PIVS' : ''} - ${this.codQma} - ${this.dataRelatorio}`
    }
  },
  mounted () {
  },
  methods: {
    onLoad () {
      this.generatePDF(this.formSearch)
    },
    onSelect (value) {
      this.$router.push(`/QMA/Consulta/PIVS/Detalhes?Detalhes=${value.id}`)
    },
    createImageHeaderFooter (imgHref) {
      const img = document.createElement('img')
      img.src = imgHref
      img.style.border = 'none'
      return img
    },
    dataFormatadaPdf () {
      var dataAtual = new Date()
      var ano = dataAtual.getFullYear()
      var mes = ('0' + (dataAtual.getMonth() + 1)).slice(-2)
      var dia = ('0' + dataAtual.getDate()).slice(-2)
      this.dataFormatada = dia + '/' + mes + '/' + ano
    },
    async getQmaSelected (value) {
      this.propApr = null
      loading.push()
      await inqueryQmaRepository.GetQmaSelected(value)
        .then(Response => {
          this.propApr = {...Response.data[0]}
          loading.pop()
        })
        .catch(err => {
          console.log(err)
          loading.pop()
        })
    },
    GetAllQma () {
      loading.push()
      this.formSearch.Fluxo = this.qma
      inqueryQmaRepository.GetAllLvPitPivs(this.formSearch, this.$refs.tableInqueryQmaPivs.pagingLimit, this.$refs.tableInqueryQmaPivs.pagingIndex)
        .then((Response) => {
          loading.pop()
          this.$refs.tableInqueryQmaPivs.LoadAllByData(Response)
          this.listaPivs = Response.data.data
        })
        .catch((err) => {
          loading.pop()
          console.log(err)
        })
    },
    async generatePDF (obj) {
      loading.push()
      let diaAtual = new Date()
      let dia = diaAtual.getDate() < 10 ? '0' + diaAtual.getDate() : diaAtual.getDate()
      let mes = diaAtual.getMonth() + 1
      if (mes < 10) {
        mes = '0' + mes
      }
      this.codQma = obj.codigoTemplate
      let ano = diaAtual.getFullYear()
      this.dataRelatorio = dia + '/' + mes + '/' + ano
      await this.getQmaSelected(obj.id)
      await this.$refs.html2Pdf.generatePdf()
      loading.pop()
    },
    async abrirNovaGuia ({ html2pdf, options, pdfContent }) {
      loading.push()
      const headerImage = new URL(cabecalhoPng, window.location.origin)
      const headerPdf = this.createImageHeaderFooter(headerImage.href)

      options.margin = [1.4, 0, 1.1, 0]
      await html2pdf().set(options).from(pdfContent).toPdf().get('pdf').then((pdf) => {
        const totalPages = pdf.internal.getNumberOfPages()
        for (let i = 1; i <= totalPages; i++) {
          pdf.addImage(headerPdf, 'PNG', 0, 0, 8.5, 0)
          pdf.setPage(i)
          pdf.setFillColor(28, 98, 40)
          pdf.rect(0, pdf.internal.pageSize.getHeight() - 0.3, pdf.internal.pageSize.getWidth(), 10, 'F')
          pdf.setTextColor('#fff')
          pdf.setFont('Helvetica', 'bold')
          pdf.setFontSize(10)
          pdf.text(
            this.nomeArquivo,
            0.5,
            pdf.internal.pageSize.getHeight() - 0.1
          )
          pdf.text(
            'Pág ' + i + ' de ' + totalPages,
            7,
            pdf.internal.pageSize.getHeight() - 0.1
          )
          if (i === totalPages) {
            pdf.setLineWidth(0.0)
            pdf.setDrawColor(54, 54, 54)
            const lineHeight = pdf.internal.pageSize.getHeight() - 0.8
            pdf.line(0.25, lineHeight, 2.5, lineHeight)
            pdf.line(3, lineHeight, 5.25, lineHeight)
            pdf.setTextColor('#666')
            pdf.setFont('Helvetica', 'bold')
            pdf.text(
              'Responsável pela Atividade',
              0.5,
              pdf.internal.pageSize.getHeight() - 0.6
            )
            pdf.text(
              'Segurança do Trabalho',
              3.35,
              pdf.internal.pageSize.getHeight() - 0.6
            )
          }
        }
      }).save()
      loading.pop()
    }
  }
}

</script>

<style scoped>
.title-checklist,
.title-risk,
.title-medias,
.title-signature {
  font-size: 16px;
  color: #008144;
  font-family: 'Segoe UI';
  font-weight: bold;
  break-inside: avoid;
  break-before: avoid;
}
.lfAnalysis {
  display: flex;
  flex-direction: row;
}
.statusTemplate {
  font-size: 14px;
  font-weight: bold;
}
.analysisRisk{
  display: flex;
  align-items: center;
  flex-direction: row;
  background-color: #F4F4F4;
  padding: 1rem;
  gap: 1rem;
  border-radius: 10px;
  justify-content: space-between;
}
.iconHat{
  background-color: #e8e8e8;
  border-radius: 5px;
}
.titleNumberApr{
  font-family: 'Segoe UI';
  font-size: 18px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.addressApr, .addressDiv{
  display: flex;
}

.responsableApr,
.dateExpire,
.dateApr {
  display: flex;
}

.dateResponsable{
  display: flex;
  gap: 1rem;
  justify-content: space-between;
}
.font-info {
  font-weight: bold;
}
.font-title, .font-info {
  font-family: 'Segoe UI';
  font-size: 14px;
}
.revisao{
  color: #008144;
  font-weight: bold;
  font-family: 'Segoe UI';
  font-size: 16px;
}
.numberApr, .numbreRevisao{
  display: flex;
  align-items: center;
}
.numbreRevisao {
  justify-content: flex-end;
}
.title-template,
/* .analysis-template, */
.container_ocorrencias,
.causa_raiza_result,
.title-signature,
.signaturelists{
  break-inside: avoid;
}
.checklist {
  break-after: avoid;
}
.container-pdf{
  padding: 2rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  border-radius: 10px;
  font-family: 'Segoe UI';
  font-weight: 500;
}
.title-template {
  display: flex;
  flex-direction: column;
  background-color: #F4F4F4;
  padding: 1rem;
  gap: 1rem;
  border-radius: 10px;
}
.info-pdf {
  display: flex;
}
.container_ocorrencias_filtradas {
  width: 100%;
  height: 2rem;
  border-radius: 5px 5px 0 0;
  background: #008144;
  display: flex;
  justify-content: space-around;
}
.font{
        color: #FFF;
        font-family:'Segoe UI';
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 27px;
    }
    .numero_oce,
    .tecnico_oce,
    .engenheiro_oce,
    .causa_raiza {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .numero_oce_result,
    .tecnico_oce_result,
    .engenheiro_oce_result {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .font_result {
        color: #1A1818;
        font-family:'Segoe UI';
        text-align: center;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 27px;
    }
    .container_ocorrencias {
      width: 100%;
      margin: 1rem 0;
      display: flex;
      justify-content: space-around;
    }
    .causa_raiza_result {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .icone-img {
      max-width: 6rem;
      max-height: 6rem;
    }
</style>



// WEBPACK FOOTER //
// src/views/private/qma/inqueryQma/inqueryQmaPivs/components/inqueryQmaPivsTable/components/inqueryQmaPivsDetails/inqueryPdf.vue